import React from 'react';
import useSWR from 'swr';
import { silentFetcher } from '../utils/errors';

const InvoiceLabel = ({id, ...props}) => {

    const { data } = useSWR(
        id ? `/api/invoices/${id}/tag` : undefined,
        silentFetcher,
        {
            revalidateOnFocus: false
        },
    );
    return data ? data?.identifier : (<></>);
}

export default InvoiceLabel;